// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-321b1c15]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.edit-allow-country-setting .country-tag-list[data-v-321b1c15]{display:flex;flex-wrap:wrap}.edit-allow-country-setting .country-tag-list .country-tag-item[data-v-321b1c15]{margin-right:4px;margin-top:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
